"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var domain = 'https://userlike-cdn-widgets.s3-eu-west-1.amazonaws.com';
var maxAttempts = 10;
var currentLoadAttempt = 0;
var currentOpenAttempt = 0;
/* eslint-disable */

var loadScript = function loadScript(providerKey) {
  if (window.userlike) return;
  var d = document;

  function l() {
    var _x$parentNode;

    var s = d.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = "".concat(domain, "/").concat(providerKey, ".js");
    var x = d.getElementsByTagName('script')[0];
    (_x$parentNode = x.parentNode) === null || _x$parentNode === void 0 ? void 0 : _x$parentNode.insertBefore(s, x);
  }

  l();
};
/* eslint-enable */


var attemptLoad = function attemptLoad(setState) {
  if (currentLoadAttempt === maxAttempts) {
    return;
  }

  if (!window.userlike) {
    currentLoadAttempt += 1;
    setTimeout(function () {
      return attemptLoad(setState);
    }, 1000); // Try every second

    return;
  }

  setTimeout(function () {
    return setState('complete');
  }, 2000);
};

var load = function load(_ref) {
  var providerKey = _ref.providerKey,
      setState = _ref.setState;
  loadScript(providerKey);
  attemptLoad(setState);
};

var open = function open() {
  if (currentOpenAttempt === maxAttempts) {
    return;
  }

  if (!window.userlike) {
    currentOpenAttempt += 1;
    setTimeout(open, 1000); // Try every second

    return;
  }

  window.userlike.userlikeStartChat();
};

var close = function close() {
  return window.userlike && window.userlike.userlikeQuitChat();
};

var _default = {
  domain: domain,
  load: load,
  open: open,
  close: close
};
exports.default = _default;